const getNotCoveredItems = (): string[] => [
  'Any amount above the policy limits as shown in the Policy Schedule',
  'Any claims where sludge is found to be the material cause of the problem or fault',
  'Intermittent faults or faults where there is not a total failure of the primary heating system.',
  'Boilers with an output of over 70kWh',
  'Where your home is unoccupied for more than 60 days',
  'Any claim arising from your deliberate act, omission or misrepresentation',
  'Cleaning and general or routine maintenance',
  'Any property owned or used for business purposes',
  'Gas leaks',
  'Any claims arising from faulty workmanship, manufacturers defect or recall',
  'Claims for incidents that happen within 14 days of the start date of your first period of insurance, unless you give us evidence that you had a similar insurance policy in place up to the start date with no break in cover.',
];

export { getNotCoveredItems };
